export const CORE_CLASSNAME = '__CORE__';

export default (coreClasses, conditionalObject) => {
  return coreClasses
    .filter(_ => _)
    .reduce((conditionalClasses, coreClass) => {
      Object.keys(conditionalObject).forEach(conditionalClass => {
        conditionalClasses[conditionalClass.replace(CORE_CLASSNAME, coreClass)] =
          conditionalObject[conditionalClass];
      });
      return conditionalClasses;
    }, {});
};
